import { render, staticRenderFns } from "./NewUi.vue?vue&type=template&id=2a949a7a&scoped=true"
import script from "./NewUi.vue?vue&type=script&lang=ts"
export * from "./NewUi.vue?vue&type=script&lang=ts"
import style0 from "./NewUi.vue?vue&type=style&index=0&id=2a949a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a949a7a",
  null
  
)

export default component.exports